import React from 'react';
import { Navbar, Container, Nav } from 'react-bootstrap';
import { FaWhatsapp, FaArrowLeft } from 'react-icons/fa';
import { Link, useLocation } from 'react-router-dom';

import brandLogo from '../images/brand-logo.png';
import { WHATSAPP_URL } from '../utils/whatsapp';

import Button from './Button';

function AppNavbar() {
  const location = useLocation();
  const isCotizadorPage = location.pathname.includes('cotizador');

  return (
    <Navbar
      variant="dark"
      expand="lg"
      className="shadow-sm py-4"
      style={{ backgroundColor: 'var(--color-brand-primary)' }}
    >
      <Container fluid className="px-3 px-md-5 flex-grow-1">
        <Navbar.Brand as={Link} to="/" className="d-flex align-items-center">
          <img
            src={brandLogo}
            alt="Multicotizador"
            height="36"
            className="d-none d-sm-inline-block align-top"
          />
          <img
            src={brandLogo}
            alt="Multicotizador"
            height="26"
            className="d-inline-block d-sm-none align-top"
          />
        </Navbar.Brand>
        <Navbar.Toggle aria-controls="navbar-nav" className="border-0" />
        <Navbar.Collapse id="navbar-nav" className="justify-content-end mt-3 mt-lg-0">
          <Nav className="d-flex flex-column flex-lg-row align-items-end align-items-lg-center gap-2">
            {isCotizadorPage && (
              <Button
                to="/"
                variant="outline-light"
                className="d-flex align-items-center gap-2 px-4"
              >
                <FaArrowLeft />
                Volver a ingresar mis datos
              </Button>
            )}
            <Button
              as="a"
              href={WHATSAPP_URL}
              target="_blank"
              rel="noopener noreferrer"
              variant="danger"
              className="d-flex align-items-center gap-2 px-4 border-0 text-white"
            >
              <FaWhatsapp />
              Contacto
            </Button>
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
}

export default AppNavbar;
